/**
 * @generated SignedSource<<ca66b755ab974ac822ced6479a8db7be>>
 * @relayHash 6381e1bc60c40368c48ad794da8d6949
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 6381e1bc60c40368c48ad794da8d6949

import { ConcreteRequest } from 'relay-runtime';
export type useFormatPhoneNumberCountriesQuery$variables = Record<PropertyKey, never>;
export type useFormatPhoneNumberCountriesQuery$data = {
  readonly displayableCountries: ReadonlyArray<{
    readonly countryLookup: {
      readonly dialCode: string;
      readonly mask: string | null;
    };
  }>;
};
export type useFormatPhoneNumberCountriesQuery = {
  response: useFormatPhoneNumberCountriesQuery$data;
  variables: useFormatPhoneNumberCountriesQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "kind": "Literal",
    "name": "language",
    "value": "en"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "mask",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "dialCode",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "useFormatPhoneNumberCountriesQuery",
    "selections": [
      {
        "alias": null,
        "args": (v0/*:: as any*/),
        "concreteType": "CountryLookupTranslation",
        "kind": "LinkedField",
        "name": "displayableCountries",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "CountryLookup",
            "kind": "LinkedField",
            "name": "countryLookup",
            "plural": false,
            "selections": [
              (v1/*:: as any*/),
              (v2/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": "displayableCountries(language:\"en\")"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "useFormatPhoneNumberCountriesQuery",
    "selections": [
      {
        "alias": null,
        "args": (v0/*:: as any*/),
        "concreteType": "CountryLookupTranslation",
        "kind": "LinkedField",
        "name": "displayableCountries",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "CountryLookup",
            "kind": "LinkedField",
            "name": "countryLookup",
            "plural": false,
            "selections": [
              (v1/*:: as any*/),
              (v2/*:: as any*/),
              (v3/*:: as any*/)
            ],
            "storageKey": null
          },
          (v3/*:: as any*/)
        ],
        "storageKey": "displayableCountries(language:\"en\")"
      }
    ]
  },
  "params": {
    "id": "6381e1bc60c40368c48ad794da8d6949",
    "metadata": {},
    "name": "useFormatPhoneNumberCountriesQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "20bef06dd0b9dd47e6c90de251d5d489";

export default node;
